import { inject as service } from '@ember/service';
import Route from 'mewe/routes/route';

import CurrentUserStore from 'mewe/stores/current-user-store';
import Session from 'mewe/shared/session';
import AccountApi from 'mewe/api/account-api';
import { isInJail, isLocked } from 'mewe/utils/jail-utils';

export default Route.extend({
  routing: service('-routing'),

  queryParams: {
    link: {},
  },

  model(params, transition) {
    let { to: toRouteInfo } = transition;

    this.link = toRouteInfo.queryParams.link;

    this.checkAuthentication();

    return {
      link: this.link,
      isLoggedIn: false,
    };
  },

  checkAuthentication() {
    Session.isAuthenticated().then(({ isAuthenticated }) => {
      if (!isAuthenticated) {
        this.set('currentModel.isLoggedIn', false);
        this.get('routing').transitionTo('login', []);
        return;
      }

      AccountApi.getCurrentUser().then((data) => {
        CurrentUserStore.send('handle', data, true);

        if (isInJail(data)) {
          this.get('routing').transitionTo('lockout');
        } else if (isLocked(data)) {
          this.get('routing').transitionTo('verify');
        } else {
          this.set('currentModel.isLoggedIn', true);
        }
      });
    });
  },
});
